import { clearAllLoaders } from '@/redux/slices/common';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
const CancelPolicy = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearAllLoaders());
  }, []);
  return <div className="terms-conditions" data-sentry-component="CancelPolicy" data-sentry-source-file="cancelPolicy.jsx">
            <div className="container pt-2 pb-6">
                <div className="terms-conditions-wrapper">
                    <div className="terms-conditions-txt">
                        <h3>Order Cancel Policy:</h3>
                        <p>
                            Please note that all orders shall be considered as confirmed unless you cancel the order
                            before it is dispatched to you. You need to call us in order to cancel your order or to
                            change your order before its dispatch. There are no cancellation charges if you cancel your
                            order in the given timelines.
                        </p>
                        <p>Once the order is dispatched there shall not be any cancellation.</p>
                        <p>Chicking reserves the right to change its order cancel policies and terms at any time.</p>
                        <p>
                            Customers can reach Chicking via email{' '}
                            <a href="mailto:contactus@chickinguae.com">contactus@chickinguae.com</a> or by phone at 600
                            59 59 58.
                        </p>
                    </div>
                </div>
            </div>
        </div>;
};
export default CancelPolicy;